import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AiFormDraft } from '../../../core/forms/ai-form.types';
import { ChatMessage } from 'src/app/cyn/chat-module/types/chat-session.types';
import { AgentFormService } from 'src/app/services/agent-form.service';
import { AgentBlockComponent } from '../agent-block.base';

@Component({
    selector: 'chat-form-draft-block', standalone: true, imports: [CommonModule],
    templateUrl: './chat-form-draft-block.component.html',
    styleUrls: ['../chat-registry-link-block/chat-registry-link-block.component.scss', './chat-form-draft-block.component.scss'],
})
export class ChatFormDraftBlockComponent extends AgentBlockComponent<'form_draft', { draftId: string }> {
    @Input() override message!: ChatMessage<'form_draft', { draftId: string }>;
    draft: AiFormDraft | null = null;
    error = '';
    constructor(private readonly forms: AgentFormService) { super(); }
    get visited(): boolean { return !!this.forms.drafts.get(this.draft?.id ?? '')?.visitedAt; }
    open(): void {
        try { this.forms.open(this.draft!.id); }
        catch (error) { this.error = error.message; }
    }
    protected override async validateBeforeRender(): Promise<boolean> {
        this.draft = this.forms.drafts.get(this.message.payload?.draftId ?? '');
        return typeof this.message.payload?.draftId === 'string';
    }
}
